customElements.get("media-gallery") || customElements.define("media-gallery", class extends HTMLElement {
	constructor() {
		super(), this.elements = {
			liveRegion: this.querySelector('[id^="GalleryStatus"]'),
			viewer: this.querySelector('[id^="GalleryViewer"]'),
			thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
		}, this.mql = window.matchMedia("(min-width: 750px)"), this.elements.thumbnails && (this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500)), this.elements.thumbnails.querySelectorAll("[data-target]").forEach((e => {
			e.querySelector("button").addEventListener("click", this.setActiveMedia.bind(this, e.dataset.target, !1))
		})), "stacked" !== this.dataset.desktopLayout && this.mql.matches && this.removeListSemantic())
	}
	onSlideChanged(e) {
		const t = this.elements.thumbnails.querySelector(`[data-target="${e.detail.currentElement.dataset.mediaId}"]`);
		this.setActiveThumbnail(t)
	}
	setActiveMedia(e, t) {
    let i = this.elements.viewer?.querySelector(`[data-media-id="${e}"]`);
  
    // 🚨 Fallback: si no encuentra el media, creamos un <img> dinámicamente
    if (!i) {
      console.warn("[setActiveMedia] Media not found for id:", e);
  
      // Intentar obtener la imagen desde la galería o featured_media.src
      let imgSrc = '';
      const galleryThumb = this.elements.thumbnails?.querySelector(`[data-target="${e}"] img`);
      if (galleryThumb?.src) {
        imgSrc = galleryThumb.src; // Clonar desde la galería
      } else if (this.featured_media?.src) {
        imgSrc = this.featured_media.src; // Usar featured_media.src como fallback
      } else {
        console.error("[setActiveMedia] No image source found for fallback, aborting.");
        return;
      }
  
      // Crear el nuevo elemento <img>
      i = document.createElement('img');
      i.setAttribute('data-media-id', e);
      i.src = imgSrc;
      i.alt = `Media ${e}`; // Añadir alt para accesibilidad
      i.classList.add('media-item'); // Clase para estilos consistentes
  
      // Insertar el nuevo elemento en el viewer
      if (!this.elements.viewer) {
        console.error("[setActiveMedia] Viewer element not found, cannot append image.");
        return;
      }
      this.elements.viewer.appendChild(i);
    }
  
    // Quitar clase activa de todos los elementos
    this.elements.viewer.querySelectorAll("[data-media-id]").forEach((el) => {
      el.classList.remove("is-active");
    });
  
    // Marcar el actual como activo
    i.classList.add("is-active");
  
    if (t) {
      // Mover al frente
      if (i.parentElement) {
        i.parentElement.prepend(i);
      }
  
      // Manejar thumbnails
      if (this.elements.thumbnails) {
        const thumb = this.elements.thumbnails.querySelector(`[data-target="${e}"]`);
        if (thumb?.parentElement) {
          thumb.parentElement.prepend(thumb);
        }
      }
  
      // Reiniciar slider si existe
      if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
        this.elements.viewer.resetPages();
      }
    }
  
    // Prevenir sticky header
    if (typeof this.preventStickyHeader === 'function') {
      this.preventStickyHeader();
    }
  
    // Desplazar al elemento activo
    window.setTimeout(() => {
      if (this.elements.thumbnails && i.parentElement) {
        i.parentElement.scrollTo({ left: i.offsetLeft, behavior: 'smooth' });
        if (this.dataset?.desktopLayout !== "stacked") {
          i.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 0);
  
    // Reproducir el medio activo
    if (typeof this.playActiveMedia === 'function') {
      this.playActiveMedia(i);
    }
  
    // Manejar thumbnails y live region
    if (this.elements.thumbnails) {
      const s = this.elements.thumbnails.querySelector(`[data-target="${e}"]`);
      if (s) {
        if (typeof this.setActiveThumbnail === 'function') {
          this.setActiveThumbnail(s);
        }
        if (s.dataset.mediaPosition && typeof this.announceLiveRegion === 'function') {
          this.announceLiveRegion(i, s.dataset.mediaPosition);
        }
      }
    }
  }
	setActiveThumbnail(e) {
		this.elements.thumbnails && e && (this.elements.thumbnails.querySelectorAll("button").forEach((e => e.removeAttribute("aria-current"))), e.querySelector("button").setAttribute("aria-current", !0), this.elements.thumbnails.isSlideVisible(e, 10) || this.elements.thumbnails.slider.scrollTo({
			left: e.offsetLeft
		}))
	}
	announceLiveRegion(e, t) {
		const i = e.querySelector(".product__modal-opener--image img");
		i && (i.onload = () => {
			this.elements.liveRegion.setAttribute("aria-hidden", !1), this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace("[index]", t), setTimeout((() => {
				this.elements.liveRegion.setAttribute("aria-hidden", !0)
			}), 2e3)
		}, i.src = i.src)
	}
	playActiveMedia(e) {
		window.pauseAllMedia();
		const t = e.querySelector(".deferred-media");
		t && t.loadContent(!1)
	}
	preventStickyHeader() {
		this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header"), this.stickyHeader && this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"))
	}
	removeListSemantic() {
		this.elements.viewer.slider && (this.elements.viewer.slider.setAttribute("role", "presentation"), this.elements.viewer.sliderItems.forEach((e => e.setAttribute("role", "presentation"))))
	}
});